module.exports = __webpack_public_path__ + "img/center-2016-softpower.0b0dc4ad.jpg";